import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  items: [],
  status: "idle",
  error: null,
};

//data fetching

export const singleCategoryFetching = createAsyncThunk(
  "singleCategory/CategoryFetching",
  async (categoryId) => {
    const res = await axios.get(
      `${process.env.REACT_APP_URL}/api-categories/${categoryId}`
    );
    return res.data;
  }
);

export const singleCategorySlice = createSlice({
  name: "singleCategory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(singleCategoryFetching.pending, (state, action) => {
      state.status = "loading...";
    });
    builder.addCase(singleCategoryFetching.fulfilled, (state, action) => {
      state.status = "success";
      state.items = action.payload;
    });
    builder.addCase(singleCategoryFetching.rejected, (state, action) => {
      // state.status = "Failed";
      state.error = action.error.message;
    });
  },
});

export default singleCategorySlice.reducer;
